// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/._core-js@2.4.1@core-js/library/modules/_defined.js
// module id = 39
// module chunks = 0